module.exports = __webpack_public_path__ + "img/dash.77a4653c.svg";